export * from "./catalogs.model";
export * from "./catalogs.service";
export * from "./catalogs.resolve";


// WEBPACK FOOTER //
// ./src/app/shared/catalogs/index.ts